import { useEffect, useState } from 'react';

/**
 * هوک بررسی media query - برای رسپانسیو کردن کامپوننت‌ها استفاده می‌شود.
 * @param {string} query
 * @returns {boolean}
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    mql.addEventListener?.('change', handler);
    setMatches(mql.matches);
    return () => mql.removeEventListener?.('change', handler);
  }, [query]);

  return matches;
};

export const useIsMobile = () => useMediaQuery('(max-width: 768px)');
export const useIsTablet = () => useMediaQuery('(max-width: 1024px)');
